import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth, API } from '../App';
import UpgradeScreen from '../components/UpgradeScreen';
import { hasFullAccess } from '../lib/platform';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { Avatar, AvatarFallback, AvatarImage } from '../components/ui/avatar';
import {
  MapPin,
  Users,
  Search,
  Crown,
  Mail,
  ChevronLeft,
  UserCheck,
  Network,
  Handshake,
  Calendar,
  ExternalLink,
  Briefcase,
  Star,
  Play,
  X,
  Phone,
  Gift,
  Building2,
  Sparkles,
  Video,
  Ticket,
  Pencil,
  Trash2,
  Plus
} from 'lucide-react';


const LAUNCH_GUESTS = [
  { name: "Shirley Juanga", profession: "Salarié intéressé par l'immobilier" },
  { name: "Cindy Portier", profession: "Professionnel de l'immobilier" },
  { name: "Eléonore Dal Bello", profession: "Salarié intéressé par l'immobilier" },
  { name: "Mathieu Hole", profession: "Chef d'entreprise / indépendant" },
  { name: "Alexia Léon", profession: "Chef d'entreprise / indépendant" },
  { name: "Eddy Magnouloux", profession: "Chef d'entreprise / indépendant" },
  { name: "Emmanuel Georgin", profession: "Conseiller en Investissement Financier" },
  { name: "Angélique André de l'Arc", profession: "Chef d'entreprise / indépendant" },
  { name: "Mathilde Charlopeau", profession: "CPME syndicat patronal" },
  { name: "Rémi Pereira", profession: "Chef d'entreprise / indépendant" },
  { name: "Anne Cécile Garin", profession: "Professionnel de l'immobilier" },
  { name: "Richard Martinez", profession: "Professionnel de l'immobilier" },
  { name: "Camille Melgarejo", profession: "Salarié intéressé par l'immobilier" },
  { name: "Patricia Troel", profession: "Salarié intéressé par l'immobilier" },
  { name: "Amaury Kressmann", profession: "Professionnel de l'immobilier" },
  { name: "Noémie Zarka", profession: "Chef d'entreprise / indépendant" },
  { name: "Dounia Sidi-Boulenouar", profession: "Notaire" },
  { name: "Maria Pieczykolan", profession: "Invitée" },
  { name: "Ivana Sousa", profession: "Invitée" },
  { name: "Céline Fermigier", profession: "Gestionnaire de patrimoine" },
  { name: "Sylvain Vidon", profession: "Chef d'entreprise / indépendant" },
  { name: "Nicolas Serdon", profession: "Investisseur particulier" },
  { name: "Alexandre Denys", profession: "Chef d'entreprise / indépendant" },
  { name: "David Roger", profession: "Investisseur particulier" },
  { name: "Jean-Marc Trescases", profession: "Professionnel de l'immobilier" },
  { name: "Vincent Hombourger", profession: "Investisseur particulier" },
  { name: "Camille Fornoni", profession: "Investisseur particulier" },
  { name: "Julien Lambert", profession: "Chef d'entreprise / indépendant" },
  { name: "Pierre Chrysanthos", profession: "Professionnel de l'immobilier" },
  { name: "Maxence Mallarme", profession: "Professionnel de l'immobilier" },
  { name: "Stéphane Brousse", profession: "Professionnel de l'immobilier" },
  { name: "Arif Yasar", profession: "Chef d'entreprise / indépendant" },
  { name: "Levent Turan", profession: "Professionnel de l'immobilier" },
  { name: "Joris Burnichon", profession: "Investisseur particulier" },
  { name: "Victor Lafond", profession: "Professionnel de l'immobilier" },
  { name: "Stéphane Ponserre", profession: "Professionnel de l'immobilier" },
  { name: "Ylan Laib", profession: "Professionnel de l'immobilier" },
  { name: "Georges Sayar", profession: "Investisseur particulier" },
  { name: "Martin Dubos", profession: "Avocat fiscaliste" },
  { name: "Romain Meynaud", profession: "Chef d'entreprise / indépendant" },
  { name: "Agathe Robinet", profession: "Professionnel de l'immobilier" },
  { name: "Alexandre Delvoye", profession: "Professionnel de l'immobilier" },
  { name: "Thibault Guibert", profession: "Professionnel de l'immobilier" },
  { name: "Selçuk Sarikaya", profession: "Professionnel de l'immobilier" },
  { name: "Amine Sekkai", profession: "Investisseur particulier" },
  { name: "Frédéric Ballet", profession: "Professionnel de l'immobilier" },
  { name: "Lucas Mancilla", profession: "Chef d'entreprise / indépendant" },
  { name: "Avi Korssia", profession: "Professionnel de l'immobilier" },
  { name: "Pierre Van Quackebeke", profession: "Professionnel de l'immobilier" },
  { name: "Julien Durand", profession: "Professionnel de l'immobilier" },
  { name: "Angela Laranjeira", profession: "Professionnel de l'immobilier" },
  { name: "Sara Pinto", profession: "Chef d'entreprise / indépendant" },
  { name: "Raja Souche", profession: "Investisseur particulier" },
  { name: "Anthony Calle", profession: "Investisseur particulier" },
  { name: "Hugo Zapata", profession: "Professionnel de l'immobilier" },
  { name: "Mohamed Mahfoufi", profession: "Investisseur particulier" },
  { name: "Rawan Elhabashy", profession: "Salarié intéressé par l'immobilier" },
  { name: "Yana Gavard", profession: "Chef d'entreprise / indépendant" },
  { name: "Jordane Brest", profession: "Chef d'entreprise / indépendant" },
  { name: "Silvan Prendi", profession: "Chef d'entreprise / indépendant" },
  { name: "Bryan Tannous", profession: "Investisseur particulier" },
  { name: "Alex Chaume", profession: "Professionnel de l'immobilier" },
  { name: "Sabri Sahraoui", profession: "Investisseur particulier" },
  { name: "Myriam Elguir", profession: "Professionnel de l'immobilier" },
  { name: "Nino Oliver", profession: "Chef d'entreprise / indépendant" },
  { name: "Vincent Cacciatore", profession: "Professionnel de l'immobilier" },
  { name: "Etienne Connétable", profession: "Investisseur particulier" },
  { name: "Patrick Christophe", profession: "Chef d'entreprise / indépendant" },
  { name: "Margaux Ticas Suplisson", profession: "Salarié intéressé par l'immobilier" },
  { name: "Milad Ramezani", profession: "Salarié intéressé par l'immobilier" },
  { name: "Yann Moreteau", profession: "Professionnel de l'immobilier" },
  { name: "Axel Briant", profession: "Salarié intéressé par l'immobilier" },
  { name: "Nabil Kaci", profession: "Professionnel de l'immobilier" },
  { name: "Justine Wojciechowski", profession: "Salarié intéressé par l'immobilier" },
  { name: "Colleen Randon", profession: "Investisseur particulier" },
  { name: "Valentin Kourieh-Sakr", profession: "Professionnel de l'immobilier" },
  { name: "Maxence Puppo", profession: "Chef d'entreprise / indépendant" },
  { name: "Guillaume Patinaud", profession: "Investisseur particulier" },
  { name: "Manuel Luvumbo", profession: "Chef d'entreprise / indépendant" },
  { name: "Aurelien Seguy", profession: "Chef d'entreprise / indépendant" },
  { name: "NIEDERBERGER FREDERIC", profession: "Chef d'entreprise / indépendant" },
  { name: "TOULOTTE RUDY", profession: "Professionnel de l'immobilier" },
  { name: "Corentin Denys", profession: "Investisseur particulier" },
  { name: "Greg Doux", profession: "Chef d'entreprise / indépendant" },
  { name: "Manon Villevieille", profession: "" },
  { name: "BIG BOSS 10MINVESTOR", profession: "" },
];

const DirectoryPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [members, setMembers] = useState([]);
  const [partnersData, setPartnersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [calendlyMembers, setCalendlyMembers] = useState({});
  const [activeTab, setActiveTab] = useState('club');
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingMember, setEditingMember] = useState(null);
  const [editSaving, setEditSaving] = useState(false);

  const isClubMember = hasFullAccess(user?.subscription_tier);
  const isFounder = user?.email === 'rajasalame@gmail.com';

  const fetchPartnersData = async () => {
    try {
      const r = await axios.get(`${API}/directory/members`);
      setPartnersData(r.data?.members || []);
    } catch (e) {
      console.error('[Directory] Failed to fetch partners:', e);
      setPartnersData([]);
    }
  };

  useEffect(() => {
    fetchPartnersData();
  }, []);

  useEffect(() => {
    if (isClubMember) {
      fetchMembers();
      fetchCalendlyMembers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClubMember, partnersData]);

  const openEditModal = (member) => {
    setEditingMember(member ? { ...member } : {
      id: null, name: '', company: '', profession: '', city: '',
      when: '', prepare: '', advantage: '', email: '', phone: '', videoUrl: ''
    });
    setShowEditModal(true);
  };

  const saveMember = async () => {
    if (!editingMember?.name?.trim()) {
      return;
    }
    setEditSaving(true);
    try {
      const payload = { ...editingMember };
      delete payload.id;
      delete payload.created_at;
      delete payload.updated_at;
      delete payload.order;
      if (editingMember.id) {
        await axios.put(`${API}/directory/admin/members/${editingMember.id}`, payload, { withCredentials: true });
      } else {
        await axios.post(`${API}/directory/admin/members`, payload, { withCredentials: true });
      }
      setShowEditModal(false);
      setEditingMember(null);
      await fetchPartnersData();
    } catch (e) {
      alert(e.response?.data?.detail || 'Erreur lors de la sauvegarde');
    } finally {
      setEditSaving(false);
    }
  };

  const deleteMember = async (member) => {
    if (!window.confirm(`Supprimer définitivement "${member.name}" de l'annuaire ?`)) return;
    try {
      await axios.delete(`${API}/directory/admin/members/${member.id}`, { withCredentials: true });
      await fetchPartnersData();
    } catch (e) {
      alert(e.response?.data?.detail || 'Erreur lors de la suppression');
    }
  };

  const fetchCalendlyMembers = async () => {
    try {
      const response = await axios.get(`${API}/integrations/calendly/members-with-calendly`, { withCredentials: true });
      setCalendlyMembers(response.data || {});
    } catch (error) {
      console.error('Failed to fetch Calendly members:', error);
    }
  };

  // Show upgrade screen for non-club members
  if (!isClubMember) {
    return (
      <UpgradeScreen
        icon={Users}
        iconBgClass="from-emerald-500 to-teal-600"
        iconColorClass="text-emerald-500"
        buttonGradientClass="from-emerald-500 to-teal-600"
        title="Annuaire des Membres"
        currentTier={user?.subscription_tier}
        features={[
          { icon: Network, title: "Réseau d'investisseurs", description: "Trouvez des investisseurs dans toute la France" },
          { icon: UserCheck, title: "Profils détaillés", description: "Découvrez les spécialités et localisations de chacun" },
          { icon: Handshake, title: "Opportunités de partenariat", description: "Créez des synergies pour vos projets immobiliers" }
        ]}
      />
    );
  }

  const fetchMembers = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/community/members`, { withCredentials: true });
      // Filter out members that are already in partnersData (by email or name)
      const partnerEmails = partnersData.map(p => p.email?.toLowerCase()).filter(Boolean);
      const partnerNames = partnersData.map(p => p.name?.toLowerCase());
      
      const regularMembers = response.data.filter(m => {
        const emailMatch = partnerEmails.includes(m.email?.toLowerCase());
        const nameMatch = partnerNames.includes(m.name?.toLowerCase());
        return !emailMatch && !nameMatch;
      }).map(m => ({
        ...m,
        isRegularMember: true
      }));
      
      setMembers(regularMembers);
    } catch (error) {
      console.error('Failed to fetch members:', error);
      setMembers([]);
    } finally {
      setLoading(false);
    }
  };

  // Combine partners + regular members
  const allMembers = [...partnersData, ...members];

  const filteredMembers = allMembers.filter(member => 
    member.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    member.city?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    member.profession?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    member.company?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Sort: Founder first, then partners, then regular members
  const sortedMembers = [...filteredMembers].sort((a, b) => {
    if (a.isFounder && !b.isFounder) return -1;
    if (!a.isFounder && b.isFounder) return 1;
    if (!a.isRegularMember && b.isRegularMember) return -1;
    if (a.isRegularMember && !b.isRegularMember) return 1;
    return 0;
  });

  const openVideoModal = (member) => {
    setSelectedMember(member);
    setShowVideoModal(true);
  };

  const getAvatarGradient = (name) => {
    const gradients = [
      'from-amber-500 to-orange-600',
      'from-emerald-500 to-teal-600',
      'from-blue-500 to-indigo-600',
      'from-violet-500 to-purple-600',
      'from-rose-500 to-pink-600',
      'from-cyan-500 to-sky-600',
    ];
    const index = name ? name.charCodeAt(0) % gradients.length : 0;
    return gradients[index];
  };

  const totalPartners = partnersData.length;
  const totalRegularMembers = members.length;
  const totalGuests = LAUNCH_GUESTS.length;

  const filteredGuests = LAUNCH_GUESTS.filter(g =>
    g.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    g.profession?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-emerald-50/30">
      {/* Header */}
      <nav className="bg-white border-b border-slate-200 sticky top-0 z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-4">
              <Link to="/dashboard">
                <Button variant="ghost" size="sm" className="text-slate-600 hover:text-emerald-600">
                  <ChevronLeft className="h-4 w-4 mr-1" />
                  Tableau de bord
                </Button>
              </Link>
              <Link to="/dashboard" className="hidden md:flex">
                <img src="/logo-horizontal.png" alt="10 Millions Investor" className="h-16 sm:h-20 w-auto" />
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-700" />
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-72 h-72 bg-emerald-300 rounded-full blur-3xl" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="flex items-center justify-between flex-wrap gap-6">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center">
                <Users className="w-8 h-8 text-white" />
              </div>
              <div>
                <h1 className="text-3xl font-bold text-white">Annuaire du Club</h1>
                <p className="text-emerald-100">Réseau d'investisseurs 10M INVESTOR</p>
              </div>
            </div>
            <div className="flex items-center gap-6">
              <div className="text-center px-4">
                <div className="text-3xl font-bold text-white">{totalPartners}</div>
                <div className="text-emerald-200 text-sm">Partenaires Pro</div>
              </div>
              <div className="w-px h-12 bg-white/20" />
              <div className="text-center px-4">
                <div className="text-3xl font-bold text-white">{totalRegularMembers}</div>
                <div className="text-emerald-200 text-sm">Membres</div>
              </div>
              <div className="w-px h-12 bg-white/20" />
              <div className="text-center px-4">
                <div className="text-3xl font-bold text-white">{totalGuests}</div>
                <div className="text-emerald-200 text-sm">Invités</div>
              </div>
              <div className="w-px h-12 bg-white/20" />
              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-xl">
                <Star className="w-5 h-5 text-amber-300" />
                <span className="text-white text-sm font-medium">Avantages exclusifs</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Search Bar + Tabs */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 -mt-6 relative z-10">
        <Card className="shadow-xl border-0">
          <CardContent className="p-4 space-y-3">
            <div className="relative">
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-slate-400" />
              <Input
                type="text"
                placeholder="Rechercher un membre, une profession, une ville..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-12 h-12 text-base bg-slate-50 border-0 focus:bg-white focus:ring-2 focus:ring-emerald-500 rounded-xl"
                data-testid="member-search"
              />
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => setActiveTab('club')}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all ${
                  activeTab === 'club'
                    ? 'bg-emerald-600 text-white shadow-md'
                    : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                }`}
                data-testid="tab-club"
              >
                <Crown className="w-4 h-4" />
                Membres Club ({totalPartners + totalRegularMembers})
              </button>
              {isFounder && (
              <button
                onClick={() => setActiveTab('guests')}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all ${
                  activeTab === 'guests'
                    ? 'bg-violet-600 text-white shadow-md'
                    : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                }`}
                data-testid="tab-guests"
              >
                <Ticket className="w-4 h-4" />
                Utilisateurs potentiels ({totalGuests})
              </button>
              )}
              {isFounder && activeTab === 'club' && (
                <Button
                  size="sm"
                  onClick={() => openEditModal(null)}
                  className="ml-auto bg-[#0D47A1] hover:bg-[#0A367A] gap-2"
                  data-testid="add-member-btn"
                >
                  <Plus className="w-4 h-4" />
                  <span className="hidden sm:inline">Ajouter un membre</span>
                </Button>
              )}
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Members Grid */}
      {activeTab === 'club' && (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {Array.from({ length: 8 }).map((_, i) => (
              <Card key={i} className="animate-pulse">
                <CardContent className="p-6">
                  <div className="flex items-center space-x-4">
                    <div className="w-14 h-14 rounded-full bg-slate-200" />
                    <div className="flex-1 space-y-2">
                      <div className="h-4 bg-slate-200 rounded w-3/4" />
                      <div className="h-3 bg-slate-200 rounded w-1/2" />
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        ) : filteredMembers.length === 0 ? (
          <div className="text-center py-16">
            <Users className="w-16 h-16 text-slate-300 mx-auto mb-4" />
            <p className="text-slate-500 text-lg">Aucun membre trouvé</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {sortedMembers.map((member) => (
              <Card 
                key={member.id || member.user_id} 
                className={`overflow-hidden hover:shadow-xl transition-all duration-300 group cursor-pointer border-0 ${
                  member.isFounder 
                    ? 'ring-2 ring-amber-400 bg-gradient-to-br from-amber-50 to-orange-50' 
                    : member.isCreator
                    ? 'ring-2 ring-blue-400 bg-gradient-to-br from-blue-50 to-indigo-50'
                    : !member.isRegularMember
                    ? 'ring-1 ring-emerald-200 bg-white'
                    : 'bg-white'
                }`}
                onClick={() => navigate(`/messages?user=${member.id || member.user_id}&name=${encodeURIComponent(member.name)}`)}
                data-testid={`member-card-${member.id || member.user_id}`}
              >
                <CardContent className="p-5">
                  {/* Header with Avatar */}
                  <div className="flex items-start gap-4 mb-4">
                    <div className="relative">
                      <div className={`w-14 h-14 rounded-full bg-gradient-to-br ${
                        member.isFounder ? 'from-amber-500 to-orange-600' :
                        member.isCreator ? 'from-blue-500 to-indigo-600' :
                        getAvatarGradient(member.name)
                      } flex items-center justify-center text-white font-bold text-xl shadow-lg group-hover:scale-105 transition-transform`}>
                        {member.name?.charAt(0).toUpperCase()}
                      </div>
                      {member.isFounder ? (
                        <div className="absolute -bottom-1 -right-1 w-7 h-7 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center border-2 border-white shadow-md" data-testid="crown-founder">
                          <Crown className="w-4 h-4 text-amber-900" />
                        </div>
                      ) : !member.isRegularMember ? (
                        <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-full flex items-center justify-center border-2 border-white shadow-sm" data-testid="crown-club">
                          <Crown className="w-3 h-3 text-white" />
                        </div>
                      ) : null}
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-bold text-slate-900 truncate group-hover:text-emerald-700 transition-colors">
                        {member.name}
                      </h3>
                      {member.company && (
                        <p className="text-xs text-slate-500 truncate">{member.company}</p>
                      )}
                    </div>
                  </div>

                  {/* Badge */}
                  <div className="mb-3">
                    {member.isFounder ? (
                      <Badge className="bg-gradient-to-r from-amber-500 to-orange-500 text-white border-0">
                        <Crown className="w-3 h-3 mr-1" />
                        Fondateur 10M Investor
                      </Badge>
                    ) : member.isCreator ? (
                      <Badge className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white border-0">
                        <Sparkles className="w-3 h-3 mr-1" />
                        Créateur Plateforme
                      </Badge>
                    ) : (
                      <Badge className="bg-gradient-to-r from-emerald-500 to-teal-600 text-white border-0">
                        <Star className="w-3 h-3 mr-1" />
                        Membre Club 10M Investor
                      </Badge>
                    )}
                  </div>

                  {/* Profession */}
                  {member.profession && (
                    <p className="text-sm font-medium text-emerald-700 mb-2 flex items-center gap-1">
                      <Briefcase className="w-3.5 h-3.5" />
                      {member.profession}
                    </p>
                  )}

                  {/* Location */}
                  {member.city && (
                    <p className="text-sm text-slate-500 flex items-center gap-1 mb-3">
                      <MapPin className="w-3.5 h-3.5" />
                      {member.city}
                    </p>
                  )}

                  {/* Advantage badge for partners */}
                  {member.advantage && !member.isRegularMember && (
                    <div className="mb-3">
                      <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200 text-xs">
                        <Gift className="w-3 h-3 mr-1" />
                        {member.advantage}
                      </Badge>
                    </div>
                  )}

                  {/* Actions */}
                  <div className="flex gap-2 pt-3 border-t border-slate-100">
                    <Button 
                      size="sm" 
                      className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/messages?user=${member.id || member.user_id}&name=${encodeURIComponent(member.name)}`);
                      }}
                      data-testid={`contact-btn-${member.id || member.user_id}`}
                    >
                      <Mail className="w-4 h-4 mr-1" />
                      Contacter
                    </Button>
                    {member.videoUrl && (
                      <Button 
                        size="sm" 
                        variant="outline"
                        className="border-slate-200 hover:bg-slate-100"
                        onClick={(e) => {
                          e.stopPropagation();
                          openVideoModal(member);
                        }}
                        data-testid={`video-btn-${member.id}`}
                      >
                        <Play className="w-4 h-4" />
                      </Button>
                    )}
                    {calendlyMembers[member.user_id] && (
                      <Button 
                        size="sm" 
                        variant="outline"
                        className="border-blue-200 text-blue-600 hover:bg-blue-50"
                        onClick={(e) => {
                          e.stopPropagation();
                          window.open(calendlyMembers[member.user_id], '_blank');
                        }}
                      >
                        <Calendar className="w-4 h-4" />
                      </Button>
                    )}
                    {isFounder && !member.user_id && member.id && (
                      <>
                        <Button
                          size="sm"
                          variant="outline"
                          className="border-slate-300 text-slate-600 hover:bg-slate-50"
                          onClick={(e) => { e.stopPropagation(); openEditModal(member); }}
                          data-testid={`edit-member-btn-${member.id}`}
                          title="Modifier"
                        >
                          <Pencil className="w-4 h-4" />
                        </Button>
                        <Button
                          size="sm"
                          variant="outline"
                          className="border-red-200 text-red-600 hover:bg-red-50"
                          onClick={(e) => { e.stopPropagation(); deleteMember(member); }}
                          data-testid={`delete-member-btn-${member.id}`}
                          title="Supprimer"
                        >
                          <Trash2 className="w-4 h-4" />
                        </Button>
                      </>
                    )}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
      )}

      {/* Guests Grid */}
      {activeTab === 'guests' && (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6 flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-violet-100 flex items-center justify-center">
            <Ticket className="w-5 h-5 text-violet-600" />
          </div>
          <div>
            <h2 className="text-lg font-bold text-slate-900" data-testid="guests-section-title">Invité(e)s Lancement Plateforme</h2>
            <p className="text-sm text-slate-500">{filteredGuests.length} invités — accès gratuit à la plateforme</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {filteredGuests.map((guest, idx) => (
            <Card key={idx} className="group hover:shadow-lg hover:shadow-violet-100/50 transition-all duration-300 border-slate-100 hover:border-violet-200" data-testid={`guest-card-${idx}`}>
              <CardContent className="p-4 text-center">
                <div className="relative inline-block mb-3">
                  <div className={`w-12 h-12 rounded-full bg-gradient-to-br from-violet-400 to-purple-500 flex items-center justify-center text-white font-bold text-lg shadow-md group-hover:scale-105 transition-transform`}>
                    {guest.name?.charAt(0).toUpperCase()}
                  </div>
                  <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-gradient-to-br from-violet-400 to-purple-500 rounded-full flex items-center justify-center border-2 border-white shadow-sm" data-testid={`badge-guest-${idx}`}>
                    <Ticket className="w-2.5 h-2.5 text-white" />
                  </div>
                </div>
                <h3 className="font-semibold text-slate-900 text-sm leading-tight mb-1">{guest.name}</h3>
                <p className="text-xs text-slate-500 leading-snug mb-2">{guest.profession}</p>
                <span className="inline-block text-[10px] font-semibold px-2 py-0.5 rounded-full bg-violet-100 text-violet-700">
                  Invité(e) Lancement
                </span>
              </CardContent>
            </Card>
          ))}
        </div>
        {filteredGuests.length === 0 && (
          <div className="text-center py-12 text-slate-500">
            <Users className="w-10 h-10 mx-auto mb-3 text-slate-300" />
            <p>Aucun invité trouvé pour "{searchQuery}"</p>
          </div>
        )}
      </div>
      )}

      {/* Video Modal */}
      <Dialog open={showVideoModal} onOpenChange={setShowVideoModal}>
        <DialogContent className="sm:max-w-3xl p-0 overflow-hidden">
          {selectedMember && (
            <>
              <DialogHeader className="p-6 pb-4 border-b bg-gradient-to-r from-emerald-50 to-teal-50">
                <div className="flex items-center gap-4">
                  <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${
                    selectedMember.isFounder ? 'from-amber-500 to-orange-600' : 'from-emerald-500 to-teal-600'
                  } flex items-center justify-center text-white font-bold text-lg`}>
                    {selectedMember.name?.charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <DialogTitle className="text-xl flex items-center gap-2">
                      <Video className="w-5 h-5 text-emerald-600" />
                      {selectedMember.name}
                    </DialogTitle>
                    <DialogDescription>
                      {selectedMember.profession} {selectedMember.company && `• ${selectedMember.company}`}
                    </DialogDescription>
                  </div>
                </div>
              </DialogHeader>
              <div className="relative bg-black aspect-video">
                <video 
                  controls 
                  autoPlay
                  className="w-full h-full object-contain"
                  preload="metadata"
                >
                  <source src={selectedMember.videoUrl} type="video/mp4" />
                  Votre navigateur ne supporte pas la lecture de vidéos.
                </video>
              </div>
              <div className="p-4 bg-slate-50 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  {selectedMember.email && (
                    <a href={`mailto:${selectedMember.email}`}>
                      <Button size="sm" variant="outline">
                        <Mail className="w-4 h-4 mr-1" />
                        Email
                      </Button>
                    </a>
                  )}
                  {selectedMember.phone && (
                    <a href={`tel:${selectedMember.phone.replace(/\s/g, '')}`}>
                      <Button size="sm" variant="outline">
                        <Phone className="w-4 h-4 mr-1" />
                        Appeler
                      </Button>
                    </a>
                  )}
                </div>
                <Button 
                  className="bg-emerald-600 hover:bg-emerald-700"
                  onClick={() => {
                    setShowVideoModal(false);
                    navigate(`/messages?user=${selectedMember.id}&name=${encodeURIComponent(selectedMember.name)}`);
                  }}
                >
                  <Mail className="w-4 h-4 mr-2" />
                  Contacter
                </Button>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>

      {/* Admin Edit/Create Modal */}
      <Dialog open={showEditModal} onOpenChange={setShowEditModal}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>{editingMember?.id ? 'Modifier le membre' : 'Ajouter un membre'}</DialogTitle>
          </DialogHeader>
          {editingMember && (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 py-2">
              {[
                { key: 'name', label: 'Nom complet *', placeholder: 'Prénom NOM', full: true },
                { key: 'company', label: 'Entreprise', placeholder: 'Ex: AG Conseils' },
                { key: 'profession', label: 'Profession', placeholder: 'Ex: Courtier prêt' },
                { key: 'city', label: 'Ville', placeholder: 'Ex: Lyon' },
                { key: 'email', label: 'Email', placeholder: 'contact@exemple.fr' },
                { key: 'phone', label: 'Téléphone', placeholder: '06 XX XX XX XX' },
                { key: 'advantage', label: 'Avantage Club', placeholder: 'Ex: 10% de réduction', full: true },
                { key: 'when', label: 'Quand le contacter', placeholder: 'Ex: Achat immobilier, financement...', full: true, textarea: true },
                { key: 'prepare', label: 'Documents à préparer', placeholder: 'Ex: Pièce d\'identité, avis d\'imposition...', full: true, textarea: true },
                { key: 'videoUrl', label: 'URL de la vidéo (podcast)', placeholder: 'https://...', full: true },
              ].map(f => (
                <div key={f.key} className={f.full ? 'sm:col-span-2' : ''}>
                  <label className="block text-xs font-semibold text-slate-700 mb-1">{f.label}</label>
                  {f.textarea ? (
                    <textarea
                      className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm resize-none"
                      rows={2}
                      value={editingMember[f.key] || ''}
                      onChange={e => setEditingMember({ ...editingMember, [f.key]: e.target.value })}
                      placeholder={f.placeholder}
                      data-testid={`edit-field-${f.key}`}
                    />
                  ) : (
                    <input
                      className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm"
                      type="text"
                      value={editingMember[f.key] || ''}
                      onChange={e => setEditingMember({ ...editingMember, [f.key]: e.target.value })}
                      placeholder={f.placeholder}
                      data-testid={`edit-field-${f.key}`}
                    />
                  )}
                </div>
              ))}
              <div className="sm:col-span-2 flex justify-end gap-2 pt-2">
                <Button variant="outline" onClick={() => setShowEditModal(false)} disabled={editSaving} data-testid="cancel-edit-btn">
                  Annuler
                </Button>
                <Button
                  onClick={saveMember}
                  disabled={editSaving || !editingMember.name?.trim()}
                  className="bg-[#0D47A1] hover:bg-[#0A367A]"
                  data-testid="save-member-btn"
                >
                  {editSaving ? 'Enregistrement...' : 'Enregistrer'}
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default DirectoryPage;
